import React from 'react';
import {
  Link as RouterLink, useHistory
} from 'react-router-dom';
import {
  Link,
  Container,
  makeStyles,
  Button,
} from '@material-ui/core';

import auth from '../../libs/auth';
import { useDialog } from '../../context/Dialog';
import { GoogleSignInButton } from '../Buttons';
import { AuthError } from '../Errors';

const useStyle = makeStyles((theme) => ({
  navbar: {
    paddingTop: '15px',
    paddingBottom: '15px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  nav: {
    display: 'flex',
    fontSize: '1rem',
    alignItems: 'center',
    flexWrap: 'wrap',

    '& > *': {
      fontWeight: 'bold',
      margin: '10px 0 10px 30px',

      '&, &:hover': {
        color: theme.palette.text.secondary,
      },
      '&:first-child': {
        marginLeft: 0
      }
    }
  }
}));

const PublicNavbar = () => {
  const classes = useStyle();
  const { alert } = useDialog();
  const session = auth.getSession();
  const history = useHistory();

  const googleSignIn = async () => {
    try {
      await auth.loginWithGoogle({role: 'student'});
    }
    catch (e) {
      await alert(<AuthError error={e} />, {
        title: 'Sign In Error'
      });
    }
  };

  return (
    <div className="app-navbar">
      <Container maxWidth={false}>
        <div className={classes.navbar}>
          <Link href="/">
            <img src="/devleague_logo.png" height="55" alt="Banner Logo" />
          </Link>
          <nav className={classes.nav}>
            <Link href="https://devleague.com/">Dev League</Link>
            <RouterLink to="/privacy-policy">Privacy policy</RouterLink>
            {/* <Link href="https://kingslanduniversity.com/honour-code/">Honor code</Link> */}
            <Button
              onClick={() => history.push('/student/login')}
              variant='contained'
              color='primary'
              size='large' style={{color: '#fff'}}
            >
                Login
            </Button>
          </nav>
        </div>
      </Container>
    </div>
  );
};

export default PublicNavbar;
